import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=ce3e5836&scoped=true"
import script from "./LayoutFooter.vue?vue&type=script&lang=js"
export * from "./LayoutFooter.vue?vue&type=script&lang=js"
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=ce3e5836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3e5836",
  null
  
)

export default component.exports